import { useBlockProps } from "@wordpress/block-editor";

const Save = ({ attributes }) => {
	const blockProps = useBlockProps.save();
	return (
		<div {...blockProps}>
			<div
				data-template-id={attributes.calculatorId}
				className="convertcalc-template"
			>
				This is live show
			</div>
		</div>
	);
};

export default Save;
